import GoogleAds from '../../components/GoogleAds/GoogleAds';
import LinkFarmComponent from '../wrappers/LinkFarm/LinkFarm';
import BreadCrumbComponent from '../wrappers/BreadCrumbsNav/BreadCrumbsNav';
import DHTML from '../wrappers/DHTML/DHTML';
import CertonaZone from '../wrappers/CertonaZone/CertonaZone';
import SeoMetaTag from '../../components/SeoMetaTags/SeoMetaTags'; // may required
import ImageBanner from '../wrappers/ImageBanner/ImageBanner';
import ImageMapBanner from '../wrappers/ImageMapBanner/ImageMapBanner';
import ShoppableImages from '../../components/ShoppableImages/ShoppableImages';
import VisualNav from '../wrappers/VisualNav/VisualNav';
import HotDeals from '../wrappers/HotDeals/HotDeals';
import Grid from '../wrappers/Grid/Grid';
import CategoryDeals from '../../components/CategoryDeals/CategoryDeals';
import EditorialContent from '../../components/EditorialContent/EditorialContent';
import StyledForYou from '../../components/StyledForYou/StyledForYou';
import PromotionalBanner from '../wrappers/PromotionalBanner/PromotionalBanner';
import StickyTimer from '../wrappers/StickyTimer/StickyTimer';
import QAndA from '../wrappers/QAndA/QAndA';

export default {
    ads: {
        component: GoogleAds,
    },
    breadcrumbs: {
        component: BreadCrumbComponent,
    },
    linkfarm: {
        component: LinkFarmComponent,
    },
    seoblock: {
        component: DHTML,
    },
    recommendations: {
        component: CertonaZone,
    },
    seotag: {
        component: SeoMetaTag,
    },
    imagebanner: {
        component: ImageBanner,
    },
    imagehotspots: {
        component: ImageMapBanner,
    },
    shoppableimages: {
        component: ShoppableImages,
    },
    dhtml: {
        component: DHTML,
    },
    dhtmlrte: {
        component: DHTML,
    },
    visualnav: {
        component: VisualNav,
    },
    hotdeals: {
        component: HotDeals,
    },
    gridcomponent: {
        component: Grid,
    },
    nucleus: {
        component: EditorialContent,
    },
    herovariant: {
        component: EditorialContent,
    },
    editorial: {
        component: EditorialContent,
    },
    story: {
        component: EditorialContent,
    },
    hero: {
        component: EditorialContent,
    },
    textbanner: {
        component: PromotionalBanner,
    },
    categorypromo: {
        component: CategoryDeals,
    },
    categoryhotdeals: {
        component: CategoryDeals,
    },
    styledforyou: {
        component: StyledForYou,
    },
    timer: {
        component: StickyTimer,
    },
    qanda: {
        component: QAndA,
    },
};
